import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Marca } from "./marca.model";
import { apiName } from "./data.service";

@Injectable()
export class MarcaApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Marca, done: any) {
    return this._restService.onPost(apiName, object, done);
  }

  onPut(object: Marca, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId , done);
  }

  onGetAll(done: any) {
    this._restService.onGetPostCustom(apiName + '/populado', {}, done);//busca marcas populado com modelos
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/shared/marca-api.service.ts
 **/